import React, { useEffect, useState } from "react";
import { useGetSmsTemplateWithLimitOffsetForTenantMutation, useSendBulkSMSFromPanelMutation } from "../../../features/tenant/smsTemplate/smsTemplateApi";
import toast from "react-hot-toast";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import ModalComponent from "../../../components/Tenant/ModalComponent/ModalComponent";
import { downloadCSV } from "../../../utils/downloadCSV";
import InputComponent from "../../../components/Tenant/InputComponent/InputComponent";
import { useSendBorosilBulkSmsMutation } from "../../../features/tenant/Borosil/SalesBoosterHistoryBorosilApi";


function parseCSV(string) {
    const csvHeader = string
        .slice(0, string.indexOf("\n"))
        .replace(/\s/g, "")
        .split(",");

    const csvRows = string.slice(string.indexOf("\n") + 1).split(/\r?\n/);

    console.log("csvRows: ", csvRows.length, csvRows);

    const array = csvRows
        .map((row) => {
            const values = [];
            let insideQuotes = false;
            let currentField = '';

            for (let char of row) {
                if (char === ',' && !insideQuotes) {
                    values.push(currentField.trim());
                    currentField = '';
                } else if (char === '"') {
                    insideQuotes = !insideQuotes;
                } else {
                    currentField += char;
                }
            }

            values.push(currentField.trim());
            return values;
        })
        .filter((values) => values.length === csvHeader.length)
        .map((values) => {
            const obj = csvHeader.reduce((object, header, index) => {
                object[header] = values[index].trim();
                return object;
            }, {});
            return obj;
        });

    return array;
}

function filterValidPhoneNumbers(phoneNumbers) {
    // Regular expression to match 10-digit phone numbers
    const phoneRegExp = /^\d{10}$/;

    const validPhoneNumbers = [];

    phoneNumbers.forEach((number) => {
        if (phoneRegExp.test(number)) {
            validPhoneNumbers.push({ mobile: number });
        }
    })

    return validPhoneNumbers;
}


const validTypesArr = ['scanning stopped'];

const GautamGarmentsBulkSms = () => {


    const [showModal, setShowModal] = useState(false);

    const [modalData, setmodalData] = useState();

    const handleOpenModal = (data) => {
        setShowModal(true);
        setmodalData(data);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setmodalData(null);
        setMobileNumbers('');
    };

    const [limit, setLimit] = useState(40);
    const [offset, setOffset] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [paginationResetToggle, setPaginationResetToggle] = useState(false);

    const [mobileNumbers, setMobileNumbers] = useState("");

    const [smsTemplatesArr, setSmsTemplatesArr] = useState([])

    const [
        getSmsTemplateWithLimitOffsetForTenant,
        {
            data: getSmsTemplateWithLimitOffsetForTenantData,
            isLoading: getSmsTemplateWithLimitOffsetForTenantIsLoading,
            isError: getSmsTemplateWithLimitOffsetForTenantIsError,
            error: getSmsTemplateWithLimitOffsetForTenantError,
        },
    ] = useGetSmsTemplateWithLimitOffsetForTenantMutation();

    const fetchSMSTemplates = (limit, offset) => {
        getSmsTemplateWithLimitOffsetForTenant({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
            limit: limit,
            offset: offset,
        });
    };

    useEffect(() => {
        fetchSMSTemplates(limit, offset);
    }, [limit, offset])

    const [
        sendBulkMessagePanel,
        {
            data: sendBulkMessagePanelData,
            isLoading: sendBulkMessagePanelisLoading,
            error: sendBulkMessagePanelisError,
        },
    ] = useSendBulkSMSFromPanelMutation();

    const sendBulkSms = (validNumbers, type, sendToAll) => {

        const data = {
            "tenant_id": JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
            "type": type,
            "mobiles": validNumbers,
        }
        sendBulkMessagePanel({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
            body: data
        })
    };



    useEffect(() => {

        if (sendBulkMessagePanelData && sendBulkMessagePanelData.body) {
            toast.dismiss();
            console.log("Successfully sent sendBulkMessagePanelData", sendBulkMessagePanelData);
            toast.success("SMS Sent", {
                id: "sendBulkMessagePanelData",
            })
        }

        if (sendBulkMessagePanelisError) {
            toast.dismiss();
            // console.log("Something went wrong.");
            toast.error("Something went wrong", {
                id: "sendNotificationError"
            })
        }

    }, [sendBulkMessagePanelData, sendBulkMessagePanelisError])


    const columns = [
        {
            name: "SNo",
            cell: (row, idx) => offset + Number(idx + 1),
            sortable: true,
            width: "80px",
        },

        {
            name: "Template Id ",
            cell: (row) => {
                return row.template_id;
            },
            sortable: true,
        },
        {
            name: "Message Template",
            cell: (row) => row.template_text,
            sortable: true,
        },
        {
            name: "type",
            cell: (row) => row.type,
            sortable: true,
        },
        {
            name: "sender Id",
            cell: (row) => row.sender_id,
            sortable: true,
        },
        {
            name: "Action",
            cell: (row) => (
                <div>
                    <button
                        onClick={() => handleOpenModal(row)}
                        className="flex justify-center items-center rounded bg-primary px-3 pb-1.5 break-normal pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-primary-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-primary-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-primary-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] "
                    >
                        Send
                    </button>
                </div>
            ),
            sortable: true,
            width: "100px",
        },
    ];

    useEffect(() => {
        if (getSmsTemplateWithLimitOffsetForTenantData &&
            getSmsTemplateWithLimitOffsetForTenantData.body.data) {
            const arr = [];

            getSmsTemplateWithLimitOffsetForTenantData.body.data.forEach((each) => {
                if (validTypesArr.includes(each.type)) {
                    arr.push(each);
                }
            })

            setSmsTemplatesArr(arr);
        }
    }, [getSmsTemplateWithLimitOffsetForTenantData])


    const handlePageChange = (pageNumber) => {
        const newOffset = (pageNumber - 1) * limit;
        setOffset(newOffset);
        setCurrentPage(pageNumber);
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setLimit(newPerPage);
    };

    const handleSendBulkMessages = (row) => {

        const valid = filterValidPhoneNumbers(mobileNumbers.split(/[ ,]+/));

        handleCloseModal()

        if (valid.length > 0) {
            toast(
                (t) => (
                    <span>
                        <h6 className="capitalize">{valid.length} valid mobile number</h6>
                        <div className="mt-3 d-flex">
                            <button
                                className="btn btn-outline-danger btn-sm ml-auto mr-1"
                                onClick={() => {
                                    // sendPushNotofications({
                                    //     notification_type: row.notification_type,
                                    //     mobile: valid,
                                    //     title: row.title,
                                    //     body: row.body,
                                    //     subtitle: row.subtitle,
                                    //     platform: "4",
                                    //     platform_id: "PANEL",
                                    //     sendToAll: false,
                                    // });
                                    sendBulkSms(valid, row.type, false);
                                }}
                            >
                                Send
                            </button>
                            <button
                                className="btn btn-outline-primary btn-sm mr-auto ml-1"
                                onClick={() => {
                                    toast.dismiss(t.id);
                                }}
                            >
                                Cancel
                            </button>
                        </div>
                    </span>
                ),
                {
                    id: "sendToMobiles",
                },
            );

        }else {
            toast.error("No Valid Mobile Numbers", {id : "novalidnumbers"})
        }
    };

    const [mobileCsv, setMobileCsv] = useState(null);

    const handleUploadUserMobileCsv = (e) => {
        if (e) {
            e.preventDefault();
        }

        if (!e.target.files[0]) {
            toast.error("Please select a file");
            return;
        }
        const fileReader = new FileReader();
        if (e.target.files[0]) {
            setMobileCsv(e.target.files[0]);
            fileReader.onload = function (event) {
                const text = event.target.result;
                let datas = parseCSV(text);

                console.log("datas", datas);

                const mobiles = datas.map((each) => each.mobile);
                // setMobileNumbers(datas);
                setMobileNumbers(mobiles.join(','));
            };
            fileReader.readAsText(e.target.files[0]);
        }
    };


    return (
        <div className="flex w-full bg-gray-200 h-full justify-center">
            <div className="w-full ">
                <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
                    Send Bulk Messages
                    <LinksComponent />
                </div>
                <div className="p-3">
                    <div className="p-3 w-full bg-white shadow rounded-lg">
                        <DataTableComponent
                            keyField={(row) => row.SNo}
                            columns={columns}
                            data={smsTemplatesArr}
                            totalRows={smsTemplatesArr.length}
                            handlePerRowsChange={handlePerRowsChange}
                            handlePageChange={handlePageChange}
                            paginationDefaultPage={currentPage}
                            paginationResetDefaultPage={paginationResetToggle}
                        ></DataTableComponent>
                    </div>
                </div>
            </div>
            {showModal && (
                <ModalComponent
                    size={"md"}
                    data={"nadnandand"}
                    show={showModal}
                    setShow={setShowModal}
                >
                    <div className="w-full">
                        <div className="mx-auto max-w-2xl px-2 py-2 lg:max-w-7xl lg:px-8">
                            <div className="w-full">
                                <div className="flex justify-center mb-1">
                                    <button
                                        type="submit"
                                        className="mb-2 text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg text-sm px-3 py-1.5 text-center "
                                        onClick={() =>
                                            downloadCSV(sampleData, 'mobileSample.csv')
                                        }
                                    >
                                        Sample Csv Download
                                    </button>
                                </div>
                                <div className="flex items-center justify-center w-full">
                                    <label
                                        for="dropzone-file"
                                        className="flex flex-col items-center justify-center w-full border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50   hover:bg-gray-100  "
                                    >
                                        <div className="flex flex-col items-center justify-center ">
                                            <svg
                                                aria-hidden="true"
                                                className="w-10 h-10 mb-3 text-gray-400 mt-2"
                                                fill="none"
                                                stroke="currentColor"
                                                viewBox="0 0 24 24"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    stroke-linecap="round"
                                                    strokeLinejoin="round"
                                                    stroke-width="2"
                                                    d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                                                ></path>
                                            </svg>
                                            <p className="mb-2 text-sm text-gray-500 text-center">
                                                {mobileCsv ? (
                                                    mobileCsv.name
                                                ) : (
                                                    <>
                                                        <span className="font-semibold">
                                                            Choose CSV file
                                                        </span>
                                                        <div>Click to upload or drag and drop</div>
                                                    </>
                                                )}
                                            </p>
                                        </div>
                                        <input
                                            id="dropzone-file"
                                            type="file"
                                            className="hidden"
                                            accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                            onChange={handleUploadUserMobileCsv}
                                        />
                                    </label>
                                </div>

                                <div className="p-2 mt-3 ">
                                    <div className="w-full min-h-max">
                                        <InputComponent
                                            name={"Enter Mobile Numbers"}
                                            type={"textarea"}
                                            value={mobileNumbers}
                                            setValue={setMobileNumbers}
                                            required={true}
                                            placeholder={"Enter Mobile Numbers"}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="flex justify-center mt-2">
                                <button
                                    type="submit"
                                    onClick={(e) => handleSendBulkMessages(modalData)}
                                    className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center "
                                >
                                    Send
                                </button>
                            </div>
                        </div>
                    </div>
                </ModalComponent>
            )}
        </div>
    );
};

export default GautamGarmentsBulkSms;


const sampleData = [
    { mobile: "9878987890" },
    { mobile: "8789987890" },
    { mobile: "9999997890" },
]